import { TitleButton } from '@/common/buttons/TitleButton';
import { ActionDialog } from '@/common/dialog/ActionDialog';
import { useDialog } from '@/common/dialog/DialogContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Menu, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';

export const AbvOverUnderScenActionSelect = ({entityId}) => {

  const rsrc = useRsrc();

  const { openDialog } = useDialog();

  const [actions, setActions] = useState();
  const [open, setOpen] = useState(false);

  useEffect(() => {

    rsrc.data('gtn', 'OVER_UNDER_SCEN_ACTION_OPTIONS_DATA_PLUGIN', { entity: 'OVER_UNDER_SCEN' }, 'OVER_UNDER_SCEN').then(actions => {
      setActions(actions);
    });

  }, [rsrc]);

  const handleClick = (click) => {
    setOpen(click.currentTarget);
  }

  const handleClose = () => {
    setOpen(null);
  }

  const openActionDialog = (action) => {
    openDialog(ActionDialog, {
      data:
      {
        title : action.title,
        pluginCode : action.pluginCode,
        entityId,
        entity : 'OVER_UNDER_SCEN'
      }
    });  
  }

  return (
    actions &&
    <>
      <TitleButton toolTip="Actions" icon={fas.faEdit} onClick={handleClick} />

      <Menu
        anchorEl={open}
        open={open}
        onClose={handleClose}
      >
        {actions.map((action) => (
          <MenuItem onClick={() => openActionDialog(action)} key={action.code}>
            {action.name}
          </MenuItem>
        ))}
      </Menu>

    </>
  )
}